import React from "react";
import { useForm } from "react-hook-form";

export default function Form({ defaultValues, children, onSubmit, className }) {
  const methods = useForm({ defaultValues });
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`custom-form ${className || ""}`}
    >
      {React.Children.map(children, (child) => {
        return child.props.name
          ? React.createElement(child.type, {
            ...{
              ...child.props,
              register: methods.register,
              errors: errors?.[child.props.name],
              key: child.props.name,
            },
          })
          : child;
      })}
    </form>
  );
}
